import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { OrderProvider } from './contexts/OrderContext';
import { FunnelMap } from './components/FunnelMap';
import { BridgePage } from './pages/BridgePage';
import { SalesPage } from './pages/SalesPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { Oto1Page } from './pages/Oto1Page';
import { ThankYouPage } from './pages/ThankYouPage';
import { RetargetingPage } from './pages/RetargetingPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mmlv773am95u">
      <OrderProvider data-id="element-1" data-mp="2mn5f2tci77mi">
        <div className="w-full min-h-screen bg-cream font-body text-ink" data-id="element-2" data-mp="2mjpw3ffpleft">
          <Routes data-id="element-3" data-mp="31bi8bik7icdb">
            <Route path="/" element={<BridgePage data-id="element-5" data-mp="2wk0bn6p7uxy5" />} data-id="element-4" data-mp="31ctefp14jw7l" />
            <Route path="/protocolo" element={<SalesPage data-id="element-7" data-mp="2wip6b2g4hi4x" />} data-id="element-6" data-mp="2wjqft2hhpwkj" />
            <Route path="/checkout" element={<CheckoutPage data-id="element-9" data-mp="28tmg367fagyt" />} data-id="element-8" data-mp="28ufpkexrnkkn" />
            <Route path="/oferta-especial" element={<Oto1Page data-id="element-11" data-mp="23vci6nubd29i" />} data-id="element-10" data-mp="28suveqfd63nb" />
            <Route path="/gracias" element={<ThankYouPage data-id="element-13" data-mp="23utadzydnu97" />} data-id="element-12" data-mp="23w4drynwuzzs" />
            <Route path="/retargeting" element={<RetargetingPage data-id="element-15" data-mp="3ikqz80j1f669" />} data-id="element-14" data-mp="3ijxpcqos80jw" />
          </Routes>
          <FunnelMap data-id="element-16" data-mp="3ii4t85bsoyq5" />
        </div>
      </OrderProvider>
    </BrowserRouter>;
}